import React from 'react';
import CashAssist from './CashAssist';
 
export default (props) => <CashAssist {...props}/>;

